import { render, staticRenderFns } from "./ProReviewsMassUpdate.vue?vue&type=template&id=7ab93bf0&"
import script from "./ProReviewsMassUpdate.vue?vue&type=script&lang=js&"
export * from "./ProReviewsMassUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports